import React from "react";
import { useCallback } from "react";
import { Controller } from "react-hook-form";
import { get } from "lodash";
import { StyledInputNumber } from "./InputNumber.style";
import clsx from "clsx";
import { IconButton } from "src/components/ui/baseButton";
import { DecreaseIcon, IncreaseIcon } from "./Icons";
import { NumericFormat } from "react-number-format";

const InputNumber = (props, ref) => {
  const {
    name,
    control,
    normalizes,
    hiddenAction,
    defaultValue,
    unit = "",
    ...rest
  } = props;
  const Big = require("big.js");

  const onChangeHandler = useCallback(
    ({ onChange }) =>
      (e) => {
        let val = e.target.value.replace(/[^0-9.]/g, "");

        // Check if the value passes all normalization rules
        const isPassRule =
          (normalizes && normalizes.every((normalize) => normalize(val))) ??
          true;
        if (val === "") {
          return onChange(0);
        }
        if (val && !isPassRule) {
          return;
        }

        // Convert the sanitized string to a number and call onChange
        onChange(Number(val) || 0);
      },
    [normalizes]
  );

  const removeLeadingZeros = (value) => {
    if (typeof value !== "string") {
      value = String(value);
    }
    return value.replace(/^0+(?=\d)/, "");
  };

  const onIncreasement = useCallback(
    ({ value, onChange }) => {
      const newValue = isNaN(+value) ? 1 : new Big(value).plus(1);
      onChange(isNaN(+value) ? newValue : Number(newValue));
    },
    [Big]
  );

  const onDecreasement = useCallback(
    ({ value, onChange }) => {
      const newValue = isNaN(+value) ? 1 : new Big(value).minus(1);
      if (value > 1) {
        if (value <= 1) {
          onChange(1);
        } else {
          onChange(isNaN(+value) ? newValue : Number(newValue));
        }
      }
    },
    [Big]
  );

  return !control ? (
    <>
      <div className="relative h-max">
        <StyledInputNumber
          className={clsx({ "disabled:bg-quarternary": rest?.disabled })}
          value={
            defaultValue
              ? Number(defaultValue)?.toLocaleString(undefined, {
                  maximumFractionDigits: 10,
                })
              : " "
          }
          {...rest}
          // ref={ref}
        />

        <div className="absolute flex items-start right-2 bottom-2">
          <span className="mt-auto text-sm font-normal text-tertiary">
            {unit}
          </span>
        </div>
      </div>
    </>
  ) : (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        const errorMsg = get(errors, `${name}.message`, undefined);

        return (
          <>
            <StyledInputNumber
              as={NumericFormat}
              thousandSeparator=","
              className={clsx({
                "disabled:bg-quarternary disabled:border-quarternary":
                  rest?.disabled,
                "border-vekin-message-error": Boolean(errorMsg),
              })}
              name={field.name}
              value={field.value}
              //   value={removeLeadingZeros(field.value)}
              onChange={onChangeHandler({ onChange: field.onChange })}
              {...rest}
              //   ref={ref}
              onKeyDown={(e) =>
                ["e", "E", "+", "-", "ArrowUp", "ArrowDown"]?.includes(e.key) &&
                e?.preventDefault()
              }
              onWheel={(e) => e.target.blur()}
            />
            <div className="absolute flex items-start gap-1 right-2 top-3">
              <span className="pt-2 mt-auto text-sm font-normal text-tertiary">
                {unit}
              </span>

              <div
                className={`flex gap-2 items-center ${clsx({
                  "opacity-0": hiddenAction || rest?.disabled,
                })}`}
              >
                <IconButton
                  onClick={
                    rest?.disabled
                      ? () => {}
                      : () =>
                          onIncreasement({
                            value: field.value,
                            onChange: field.onChange,
                          })
                  }
                  className={`border border-quartenary hover:bg-vekin-green-50 hover:border-quartenary ${clsx(
                    {
                      "cursor-not-allowed": rest?.disabled,
                    }
                  )}`}
                >
                  <img src={IncreaseIcon} alt="increase amount event list" />
                </IconButton>

                <IconButton
                  onClick={
                    rest?.disabled
                      ? () => {}
                      : () =>
                          onDecreasement({
                            value: field.value,
                            onChange: field.onChange,
                          })
                  }
                  className={`border border-quartenary hover:bg-vekin-green-50 hover:border-quartenary ${clsx(
                    {
                      "cursor-not-allowed": rest?.disabled,
                    }
                  )}`}
                >
                  <img
                    src={DecreaseIcon}
                    alt="decreaseIcon amount event list"
                  />
                </IconButton>
              </div>
            </div>

            {errorMsg ? (
              <label className="label !py-1 text-vekin-message-error">
                <span className="label-text-alt text-vekin-message-error">
                  {errorMsg}
                </span>
              </label>
            ) : null}
          </>
        );
      }}
    />
  );
};

InputNumber.displayName = "Input";

export default InputNumber;
